import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const autoHide = this.element.getAttribute("data-auto-hide");

    if (autoHide === "true") {
      setTimeout(() => {
        this.close();
      }, 4000);
    }
  }

  close() {
    this.element.classList.add("opacity-0");
    setTimeout(() => {
      this.element.remove();
    }, 1000);
  }

  // Full reload, e.g. a toast offering to refresh so freshly-arrived content renders. Wired via
  // data-action (not an inline onclick) to keep to the codebase's frontend conventions + CSP.
  reload() {
    window.location.reload();
  }
}
